import useAuth from "../../../auth/useAuth";
import { reassignmetRegister } from "../../../config.js";

export const useReassignmentDialog = (showErrorRequest) => {

    const auth = useAuth();
    const token = auth.globals.token;


    const reassignmentRegister = async (body) => {
        try {
            let res = await reassignmetRegister(token, body);
            let data = await res.json();
            if(!res.ok) {
                showErrorRequest("Error en el servidor, por favor intente mas tarde", auth);
            }
            console.log(res)
            return data;
        } catch (errorRequest) {
            showErrorRequest("Error en el servidor, por favor intente mas tarde", auth);
        }
    }

    
    return {
        //properties
        

        //methods
        reassignmentRegister

    }
}